// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizedFunctionalUnit
 */
export interface OrganizedFunctionalUnit {
    /**
     * 
     */
    sourceBrowsePath?: string;
    /**
     * 
     */
    targetBrowsePath?: string;
    /**
     * 
     */
    createdAt?: Date;
    /**
     * 
     */
    deletedAt?: Date;
}

/**
 * Check if a given object implements the OrganizedFunctionalUnit interface.
 */
export function instanceOfOrganizedFunctionalUnit(value: object): value is OrganizedFunctionalUnit {
    return true;
}

export function OrganizedFunctionalUnitFromJSON(json: any): OrganizedFunctionalUnit {
    return OrganizedFunctionalUnitFromJSONTyped(json, false);
}

export function OrganizedFunctionalUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizedFunctionalUnit {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceBrowsePath': json['sourceBrowsePath'] == null ? undefined : json['sourceBrowsePath'],
        'targetBrowsePath': json['targetBrowsePath'] == null ? undefined : json['targetBrowsePath'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'deletedAt': json['deletedAt'] == null ? undefined : (new Date(json['deletedAt'])),
    };
}

export function OrganizedFunctionalUnitToJSON(json: any): OrganizedFunctionalUnit {
    return OrganizedFunctionalUnitToJSONTyped(json, false);
}

export function OrganizedFunctionalUnitToJSONTyped(value?: OrganizedFunctionalUnit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceBrowsePath': value['sourceBrowsePath'],
        'targetBrowsePath': value['targetBrowsePath'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'deletedAt': value['deletedAt'] == null ? value['deletedAt'] : value['deletedAt'].toISOString(),
    };
}

